import { render } from "./ViewWarehouse.vue?vue&type=template&id=b4de4670&scoped=true"
import script from "./ViewWarehouse.vue?vue&type=script&lang=js"
export * from "./ViewWarehouse.vue?vue&type=script&lang=js"

import "./ViewWarehouse.vue?vue&type=style&index=0&id=b4de4670&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4de4670"]])

export default __exports__